export default __webpack_public_path__ + "static/OYOY-3716x752-30fps-50017eaee3493d09295d3c045dfb7ec1.mp4";